// src/components/UI/UnauthorizedMessage.jsx
import React from 'react';
import { ShieldExclamationIcon } from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';

const UnauthorizedMessage = ({ 
  title = "Acceso no autorizado",
  message = "No tienes los permisos necesarios para acceder a esta sección.",
  showDashboardLink = true 
}) => {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center px-4">
      <div className="max-w-md text-center">
        <ShieldExclamationIcon className="mx-auto h-16 w-16 text-red-500" />
        
        <h2 className="mt-6 text-2xl font-bold text-gray-900">{title}</h2>
        
        <p className="mt-3 text-gray-600">
          {message}
        </p>
        
        <div className="mt-8 space-y-4">
          {showDashboardLink && (
            <Link
              to="/dashboard"
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700"
            >
              Volver al Dashboard
            </Link>
          )}
          
          <p className="text-sm text-gray-500">
            Si crees que esto es un error, contacta con el administrador del sistema.
          </p>
        </div>
      </div>
    </div>
  );
};

export default UnauthorizedMessage;